import api from '@/api';
import { ContactFolderType, ShareType } from '../types/enums';
export default{
    /**
     * 주소록 목록 데이터를 조회합니다.
     * @param {string} parentId 폴더 root ID
     */
    getContactTree(folderType: ContactFolderType, shareType: ShareType, parentId?: string) {
        return api
            .post({
                url: `/api/contact/folder/list?type=DB&folderType=${folderType}&shareType=${shareType}`,
                data: {
                    fields: [
                        { key: 'Id' },
                        { key: 'DisplayName' },
                        { key: 'TotalCount' },
                        { key: 'ChildFolderCount' },
                        { key: 'WellKnownFolderName' },
                        { key: 'USER_IS_FAVORITE' },
                        { key: 'USER_RENDER_ORDER' },
                    ],
                    filters: [
                        {
                            key: 'FolderClass',
                            value: 'IPF.Contact',
                            condition: 'isEqualTo'
                        }
                    ],
                    parentId: parentId,
                    wellKnownParentName: 'Contacts',
                    type: 'Folder',
                    traversal: 'Shallow',
                },
            })
            .then((res: any) =>
                res.items.map((item: contacts.FolderItem) => {
                    var rlt = {
                        ...item,
                        items: null,
                        selected: false,
                        nodeStatus: null,
                        oldStatus: null,
                        folderType: folderType,
                        type: 'Folder'
                    };
                    return rlt;
                })
            );
    },

    /**
     * 주소록 폴더를 추가합니다.
     * @param {string} parentId
     * @param {string} name
     * @param {enum} folderType
     */
    addFolder(parentId: string, name: string, folderType: ContactFolderType): Promise<string> {
        const id = parentId === undefined ? null : parentId;
        return api
            .post({
                url: '/api/contact/folder/create?type=DB&folderType='+folderType,
                data: {
                    id: id,
                    name: name,
                },
            })
            .then((result: any) => result.item.id);
    },

    /**
     * 주소록 폴더를 삭제합니다.
     * @param {object} id 선택한 주소록 폴더 ID [ id ]
     */
    deleteFolder(id: Array<string>) {
        return api.delete({
            url: '/api/contact/folder?type=DB',
            data: id,
        });
    },

    /**
     * 주소록 폴더명을 수정합니다.
     * @param {string} id 주소록 폴더 ID
     * @param {string} name 변경할 폴더명
     */
    editFolderName(id: string, name: string) {
        return api.post({
            url: '/api/contact/folder/set?type=DB',
            data: {
                fields: [{ key: 'DisplayName', value: name }],
                id: id,
                type: 'Folder',
            },
        });
    },
    
    getUserInfoByPersonCode(personCode: string){
        return api.get({
            url: '/api/hr/department/info/personCode?personCode='+personCode
        });
    }
}